import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useDateFromNow } from "@/components/pages/live-usage-mgmt/utils/hooks/useDateFromNow";

interface AttachmentItemProps {
  attachTime?: string;
}

export const AttachmentItemDetachedState: FC<AttachmentItemProps> = ({
  attachTime,
}) => {
  const fromNow = useDateFromNow(attachTime);
  return (
    <Stack my={1}>
      <Typography variant="body2">Detached</Typography>
      {attachTime && (
        <Typography
          color="text.disabled"
          variant="body2"
          sx={{
            display: "inline-block",
            textDecoration: "underline",
            textDecorationStyle: "dashed",
            textUnderlineOffset: 4,
            textDecorationColor: grey["A400"],
          }}
        >
          Last detached: {fromNow + `ago`}
        </Typography>
      )}
    </Stack>
  );
};
